module.exports = __webpack_public_path__ + "img/yield_from.8796b2f0.jpg";